export default class CountResponse {
    constructor(json) {
        this.count = json["count"]
    }
}
